export default __webpack_public_path__ + "static/media/usgs_shaded.474761b4.png";